import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';

import DataMes from '../componentes/DataMes';
import TituloSessao from '../componentes/TituloSessao';
import AlcanceTotalEMensal from '../componentes/graficos/AlcanceTotalEMensal';
import BarraBuscaComTodasUnidades from '../componentes/BarraBuscaComTodasUnidades';
import HeatMapAlcanceUnidades from '../componentes/graficos/HeatMapAlcanceUnidades';
import TabelaIndicadorEstabelecimento from '../componentes/graficos/TabelaIndicadorEstabelecimento';
import LineChartDetalhamentoIndicador from '../componentes/graficos/LineChartDetalhamentoIndicador';

import { servGetGraficoAlcancePeriodo, servGetGraficoAlcanceMensal } from '../../src/servicos/graficos_indicador';
import { servGetGraficoPercentualAlcanceEstabelecimentosHeatMap } from '../servicos/graficos_indicador';
import { servGetGraficoDetalhamentoMetrica, servGetGraficoDetalhamentoEstabelecimento } from '../servicos/graficos_indicador';
import { toastErrorPydantic } from '../util/toast_pydantic';

function Graficos() {

    console.log("### INICIANDO GRAFICOS ###");

    const [estabelecimento, setEstabelecimento] = useState(null)
    const [dataInicio, setDataInicio] = useState(null) // '2025-01-01'
    const [dataFim, setDataFim] = useState(null) // '2025-12-31'

    // COL 1
    const [alcancePeriodo, setAlcancePeriodo] = useState([])
    const [alcanceMensal, setAlcanceMensal] = useState([])
    const [alcanceUnidades, setAlcanceUnidades] = useState(null)
    const [indicadoresDetalhamento, setIndicadoresDetalhamento] = useState(null)

    const getGraficoAlcancePeriodo = async () => {
        try {
            const countAlcanceTotalPesoDaApi = await toast.promise(
                servGetGraficoAlcancePeriodo(dataInicio, dataFim),
                { loading: 'Buscando alcance no período...' }
            )
            setAlcancePeriodo(countAlcanceTotalPesoDaApi)
        } catch (erro) {
            toastErrorPydantic(erro)
        }
    }

    const getGraficoAlcanceMensal = async () => {
        try {
            const indicadoresMensaisDaApi = await servGetGraficoAlcanceMensal(dataInicio, dataFim)
            setAlcanceMensal(indicadoresMensaisDaApi)
        } catch (erro) {
            toastErrorPydantic(erro)
        }
    }

    const getGraficoDetalhamentoMetrica = async () => {
        try {
            const indicadoresDetalhamentoDaApi = await servGetGraficoDetalhamentoMetrica(dataInicio, dataFim, estabelecimento)
            setIndicadoresDetalhamento(indicadoresDetalhamentoDaApi);
        } catch (erro) {
            toastErrorPydantic(erro)
        }
    }

    useEffect(() => {
        if (dataInicio && dataFim && dataInicio <= dataFim) {
            getGraficoAlcancePeriodo()
            getGraficoAlcanceMensal()
            getGraficoPercentualAlcanceEstabelecimentosHeatMap()
            // Se mudar a data, eu chamo o detalhamento sem estabelecimento.
            getGraficoDetalhamentoMetrica()
        }
    }, [dataInicio, dataFim]);

    const getGraficoPercentualAlcanceEstabelecimentosHeatMap = async () => {
        try {
            const dadosHeatMapDaApi = await servGetGraficoPercentualAlcanceEstabelecimentosHeatMap(dataInicio, dataFim)
            setAlcanceUnidades(dadosHeatMapDaApi)
        } catch (erro) {
            toastErrorPydantic(erro)
        }
    }

    useEffect(() => {
        if (dataInicio && dataFim && dataInicio <= dataFim) {
            // Se mudar apenas o estabelecimento, eu chamo apenas o detalhamento com os dados do estabelecimento.
            // Caso contrário, ele faz o fetch em tudo de novo só porque o estabelecimento mudou.
            getGraficoDetalhamentoMetrica()
        }
    }, [estabelecimento]);

    return (
        <div className='container-fluid d-flex flex-column gap-3 p-3'>
            <div className='m-0 d-flex flex-column flex-md-row justify-content-center gap-3 p-2 div-com-borda align-items-center' style={{ 'marginTop': '3em' }}>
                <div className='col-12 col-md-2 d-flex gap-1 align-items-center'>
                    <label className='text-nowrap' htmlFor='graf-data-inicial'>Data Inicio</label>
                    <DataMes id='graf-data-inicial' setData={setDataInicio} getUltimoDia={false} />
                </div>
                <div className='col-12 col-md-2 d-flex gap-1 align-items-center'>
                    <label className='text-nowrap' htmlFor='graf-data-final'>Data Fim</label>
                    <DataMes id='graf-data-final' setData={setDataFim} getUltimoDia={true} />
                </div>
                <div className='col-12 col-md-7'>
                    <BarraBuscaComTodasUnidades
                        setEstabelecimento={setEstabelecimento}
                        somenteAtivos={false}
                        enviaRelatorioAcompanhamento={false}
                    />
                </div>
            </div>
            {alcancePeriodo && alcanceMensal && indicadoresDetalhamento && alcanceUnidades
                ?
                (
                    <>
                        <TituloSessao titulo='Percentual de alcance mensal dos indicadores de desempenho' barraDecorativa={true} tituloAlignStart={true} />
                        <div style={{ 'height': '25em' }}>
                            <AlcanceTotalEMensal
                                dadosGrafPeriodo={alcancePeriodo}
                                dadosGrafMensal={alcanceMensal}
                            />
                        </div>

                        <TituloSessao titulo='Detalhamento por unidade' barraDecorativa={true} tituloAlignStart={true} />
                        <LineChartDetalhamentoIndicador
                            estabelecimento={estabelecimento}
                            dadosGraf={indicadoresDetalhamento}
                        />

                        {estabelecimento ?  /* Se passar o estabelecimento, mostro a tabela com os indicadores. */
                            <>
                                <TituloSessao titulo='Percentual de alcance por unidade' barraDecorativa={true} tituloAlignStart={true} />
                                <div className=''>
                                    <TabelaIndicadorEstabelecimento
                                        estabelecimento={estabelecimento}
                                        dataInicio={dataInicio}
                                        dataFim={dataFim}
                                    />
                                </div>
                            </>
                            :
                            <>
                                <TituloSessao titulo='Percentual de unidades que alcançaram determinado indicador' barraDecorativa={true} tituloAlignStart={true} />
                                <div style={{ 'height': '25em' }}>
                                    <HeatMapAlcanceUnidades
                                        dadosGraf={alcanceUnidades}
                                    />
                                </div>
                            </>
                        }
                    </>
                )
                :
                (
                    <div className='text-center'>
                        <p>Selecione ao menos uma <strong>data início</strong> e uma <strong>data fim</strong> para buscar as informações no banco de dados</p>
                    </div>
                )
            }
        </div>
    );
}

export default Graficos
